<style src="./FormDataInput.scss" lang="scss" scoped></style>
<template>
  <form @submit.prevent="submitForm" class="row">
    <textbox
      class="col-12"
      :autofocus="true"
      label="Identificador"
      placeholder="PP 205"
      v-model="form.identification" />

    <suggest-client
      class="col-12"
      placeholder="Marinha do brasil"
      @selected="selectedClient"
      v-model="client"/>

    <textbox
      class="col-12"
      label="Código alternativo"
      placeholder="19856"
      v-model="form.alternativeCode" />

    <div class="col-12">
      <div class="row no-side-margin between-all">
        <datebox
          class="col-6"
          label="Data do evento"
          placeholder="05/01/2078"
          v-model="eventPeriod.date" />

        <timebox
          class="col-6"
          label="Hora do evento"
          placeholder="05/01/2078"
          v-model="eventPeriod.time" />
      </div>
    </div>

    <div class="col-12">
      <div class="row no-side-margin between-all">
        <datebox
          class="col-6"
          label="Data de entrega"
          placeholder="03/01/2078"
          v-model="eventPeriod.deadlineDate" />

        <timebox
          class="col-6"
          label="Hora do evento"
          placeholder="05/01/2078"
          v-model="eventPeriod.deadlineTime" />
      </div>
    </div>

    <div class="col-12">
      <label class="checkbox-label">
        <span class="label">Participa</span>

        <input
          class="checkbox-input"
          type="checkbox"
          v-model="form.participate">
      </label>
    </div>


    <div class="commands col-12">
      <!-- <button
        class="btn-ghost col-5 cancel-button"
        type="button"
        @click="removeEvent">
        <icon-remove />
        Excluir Evento
      </button> -->

      <button-submit
        class="col-5"
        label="Atualizar Evento"
        :state="commands.submitState"
        :icon-save="commands.saveIcon"/>


    </div>
  </form>
</template>

<script>
import { Textbox, ButtonSubmit, Dropdown, Datebox, Timebox, SuggestClient } from '@/components/primitives'
import { IconSave, IconRemove } from '@/components/primitives/icons'
import EditEvent from '@/brain/event/EditEvent'
import moment from 'moment'

export default {
  name: 'FormDataInput',
  components: {
    Textbox,
    Timebox,
    Dropdown,
    Datebox,
    ButtonSubmit,
    IconSave,
    IconRemove,
    SuggestClient
  },
  props: {
    editData: {
      default: null
    }
  },
  data () {
    return {
      eventPeriod: {
        date: '',
        time: '',
        deadlineDate: '',
        deadlineTime: '090000'
      },
      form: {
        client: null,
        alternativeCode: '',
        identification: '',
        participate: true,
        status: 0
      },
      client: null,
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  watch: {
    editData (pData) {
      this.fillForm()
    }
  },
  computed: {
    eventPeriodComputed () {
      const eventOccur = `${this.eventPeriod.date} ${this.eventPeriod.time || '12:00:00'}`
      const eventDeadline = `${this.eventPeriod.deadlineDate} ${this.eventPeriod.deadlineTime || '12:00:00'}`
      return { eventOccur, eventDeadline }
    }
  },
  mounted () {
    this.fillForm()
  },
  methods: {
    fillForm () {
      if (this.editData) {
        this.client = this.editData.client.shortName
        this.form = {
          identification: this.editData.identification,
          client: this.editData.client._id,
          alternativeCode: this.editData.alternativeCode,
          participate: this.editData.participate,
          date: {
            event: moment(this.editData.date.event).format('DD/MM/YYYY'),
            deadline: moment(this.editData.date.deadline).format('DD/MM/YYYY')
          }
        }
        this.eventPeriod.date = moment(this.editData.date.event).format('DD/MM/YYYY')
        this.eventPeriod.time = moment(this.editData.date.event).format('HH:mm:ss')
        this.eventPeriod.deadlineDate = moment(this.editData.date.deadline).format('DD/MM/YYYY')
        this.eventPeriod.deadlineTime = moment(this.editData.date.deadline).format('HH:mm:ss')
      }
    },
    submitForm () {
      this.commands.submitState = 'WAIT'
      const formInformation = JSON.parse(JSON.stringify(this.form))
      formInformation.date = {
        deadline: moment(this.eventPeriodComputed.eventDeadline, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
        event: moment(this.eventPeriodComputed.eventOccur, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      }
      EditEvent(this.editData._id, formInformation)
        .then((response) => {
          this.$emit('refresh-list')
          this.commands.submitState = 'REPOSE'
        })
    },
    clearForm () {
      this.client = ''
      this.form = {
        client: '',
        alternativeCode: '',
        date: {
          created: '',
          deadline: '',
          event: ''
        },
        identification: '',
        participate: true,
        status: 0
      }
    },
    closePanel () {
      this.$emit('close', false)
    },
    selectedClient (pItem) {
      this.form.client = pItem.source._id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/components/edit-event/form-data-input/FormDataInput.vue